import { useState, useEffect } from "react";
import api from "../../services/api";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { faSquarePlus } from "@fortawesome/free-solid-svg-icons";
import { faSquareMinus } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import EditModal from "../ui/EditModal.js";
import { normalizar } from "../../common/stringNormalizer.js";

const AddPais = () => {
 const [filtroEstado, setFiltroEstado] = useState("activas");
  const [Nombre, setNombre] = useState("");
  const [paises, setPaises] = useState([]);
  const [selectedPais, setSelectedPais] = useState(null);

  useEffect(() => {
    getPaises();
  }, []);

  const editFields = [
    { name: "Nombre", label: "Nombre País", type: "text", required: true }
  ];

  const getPaises = async () => {
    const response = await api.get(`/paises`);
    setPaises(response.data);
  };

  const filtrarPaises = () => {
  if (filtroEstado === "activas") return paises.filter(p => p.estado === 1);
  if (filtroEstado === "inactivas") return paises.filter(p => p.estado === 0);
  return paises;
};

 const createPais = async (e) => {
  e.preventDefault();

  const nombreNormalizado = normalizar(Nombre.trim());

  if (!nombreNormalizado) {
    Swal.fire({
      icon: "warning",
      title: "Nombre inválido",
      text: "El nombre del país no puede estar vacío.",
    });
    return;
  }

  const existe = paises.some(
    (pais) => normalizar(pais.Nombre) === nombreNormalizado
  );

  if (existe) {
    Swal.fire({
      icon: "warning",
      title: "Duplicado",
      text: "Ya existe un país con ese nombre.",
      confirmButtonColor: "#3085d6"
    });
    return;
  }

  try {
  await api.post(`/paises`, { Nombre: nombreNormalizado });
    getPaises();
    setNombre("");
    Swal.fire({
      icon: "success",
      title: "Guardado",
      text: "El país fue guardado exitosamente.",
      timer: 1500,
      showConfirmButton: false,
    });
  } catch (error) {
    console.log(error);
    Swal.fire({
      icon: "error",
      title: "Error al guardar",
      text: "Ocurrió un problema al guardar el país.",
    });
  }
};
  const handleEditPais = async (values) => {

    try {
      await api.patch(`/paises/CambiarNombrePais/${values.IdPais}`, { Nombre: values.Nombre });
      Swal.fire({
        icon: "success",
        title: "País actualizado",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (error) {
      console.error("Error al actualizar:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al actualizar el país.",
      });
    }
    setSelectedPais(null);
    getPaises();
  };

const cambiarEstado = async (IdPais) => {
  try {
    await api.patch(`/paises/cambiarEstadoPais/${IdPais}`);
    getPaises();
    Swal.fire({
      icon: "success",
      title: "Estado actualizado",
      text: "El estado del país fue cambiado exitosamente.",
      timer: 1500,
      showConfirmButton: false
    });
  } catch (error) {
    if (error.response?.status === 409 && error.response?.data?.code === "PAIS_ASOCIADO") {
      Swal.fire({
        icon: "warning",
        title: "No se puede desactivar",
        text: error.response.data.mensaje,
        confirmButtonColor: "#3085d6"
      });
    } else {
      console.error("Error al cambiar estado:", error);
      Swal.fire({
        icon: "error",
        title: "Error al cambiar estado",
        text: "No se pudo cambiar el estado del país.",
      });
    }
  }
};

  const columnas = [
    {
      name: 'Nombre',
      selector: row => row.Nombre,
      sortable: true
    },
    {
      cell: (row) => (
        <button className="button is-small is-info mr-2" onClick={() => setSelectedPais(row)}>
          <FontAwesomeIcon icon={faPencil} />
        </button>
      ),
      right: true,
      compact: true
    },
    {
      name: "Activo",
      cell: (row) =>
        row.estado === 1 ?
          <FontAwesomeIcon icon={faSquarePlus} style={{ color: "#37ff00", cursor: "pointer" }} size="2xl" onClick={() => cambiarEstado(row.IdPais)} />
          :
          <FontAwesomeIcon icon={faSquareMinus} style={{ color: "#ff0000", cursor: "pointer" }} size="2xl" onClick={() => cambiarEstado(row.IdPais)} />,
      ignoreRowClick: true,
      AllowOverflow: true,
      button: true,
      compact: true
    }
  ];

  const paginationOptionsES = {
  rowsPerPageText: 'Filas por página',
  rangeSeparatorText: 'de',
  selectAllRowsItem: true,
  selectAllRowsItemText: 'Todos',
};
  return (
    <div className="columns mt-5 is-centered">
      <div className="column is-half">
        <div className="notification is-primary">
          <strong>Ingresa el nombre del país</strong>
        </div>
        <form onSubmit={createPais}>
          <div className="field">
            <label className="label required">Nombre País</label>
            <div className="control">
              <input
                type="text"
                className="input"
                value={Nombre}
                onChange={(e) => setNombre(e.target.value)}
                placeholder="Nombre"
                required
              />
            </div>
          </div>
          <div className="field">
            <button type="submit" className="button is-success">Guardar</button>
          </div>
        </form>

        <br />
        <div style={{ width: '700px', border: '1px solid gray', borderRadius: '8px' }}>

<div style={{ display: 'flex', gap: '10px', margin: '10px 0' }}>
  {["todas", "activas", "inactivas"].map((estado) => (
    <button
      key={estado}
      onClick={() => setFiltroEstado(estado)}
      type="button"
      style={{
        padding: "6px 16px",
        border: "none",
        borderRadius: "20px",
        backgroundColor: filtroEstado === estado ? "#d1f5d3" : "#f0f2f5",
        color: filtroEstado === estado ? "#075e54" : "#333",
        fontWeight: filtroEstado === estado ? "bold" : "normal",
        boxShadow:
          filtroEstado === estado
            ? "inset 0 0 0 1px #1ebea5"
            : "inset 0 0 0 1px #ccc",
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        fontSize: "0.9rem",
      }}
    >
      {estado.charAt(0).toUpperCase() + estado.slice(1)}
    </button>
  ))}
</div>


          <DataTable
          pagination
           paginationComponentOptions={paginationOptionsES}
          columns={columnas}
          data={filtrarPaises()}
          dense={false}
/>

        </div>

        {selectedPais && (
          <EditModal
            fields={editFields}
            initialValues={selectedPais}
            onSubmit={handleEditPais}
            onClose={() => setSelectedPais(null)}
            title="Editar País"
          />
        )}
      </div>
    </div>
  );
};

export default AddPais;